import { render } from "./DefaultPopup.vue?vue&type=template&id=f778c05e&scoped=true"
import script from "./DefaultPopup.vue?vue&type=script&lang=js"
export * from "./DefaultPopup.vue?vue&type=script&lang=js"

import "./DefaultPopup.vue?vue&type=style&index=0&id=f778c05e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f778c05e"]])

export default __exports__